/**
 * @generated SignedSource<<d1d9b8d9d355c1d2f7ef6c1b93bf029e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailFramingOptions_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_user">;
  readonly " $fragmentType": "PdpSharedDetailFramingOptions_user";
};
export type PdpSharedDetailFramingOptions_user$key = {
  readonly " $data"?: PdpSharedDetailFramingOptions_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailFramingOptions_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailFramingOptions_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "117df23663df364085d7424c56d637a9";

export default node;
